export default __webpack_public_path__ + "static/media/pbn.2ce5867f.jpg";